export const postOtpGenerate = '/otp-security-ms/ms/contact/generate';

export const postOtpCheck = '/otp-security-ms/ms/contact/check';

export const postContractOtpGenerate =
  '/otp-security-ms/v1/ms/contract/generate';

export const postContractOtpCheck = '/otp-security-ms/v1/ms/contract/check';
